import React, {Component} from "react";
import {connect} from "react-redux";
import PublicLayout from "../../components/public-layout";
import {resetUserMessage} from "../../data/actions/user";
import Resources from "../../data/services/resources";

class RegistrationInstructionsView extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.dispatch(resetUserMessage());
    }

    render() {
        const {translate} = this.props;

        return (
            <PublicLayout menuActiveResource={Resources.RegistrationInstructions} {...this.props}>
                <section className="margin-10 bgw btop">
                    <div className="container">
                        <div className="section-title-2">
                            <h2>{translate("page.registration_introductions")}</h2>
                            <p>{translate("text.registration_introductions1")}
                            <strong> {translate("text.registration_introductions2")}</strong> {translate("text.registration_introductions3")}
                            <strong> {translate("text.registration_introductions4")}</strong> {translate("text.registration_introductions5")}
                            <strong> {translate("text.registration_introductions6")}</strong> {translate("text.registration_introductions7")}</p>
                        </div>
                    </div>
                </section>

            </PublicLayout>
        );
    }
}

export default connect(state => state)(RegistrationInstructionsView);